import type { PortableTextBlock } from '@portabletext/types';

import { sanityClient } from './client';

export interface LegalPageSeo {
  metaTitle?: string;
  metaDescription?: string;
  canonicalUrl?: string;
  isHiddenFromSearch?: boolean;
  ogImage?: {
    asset?: { url?: string };
  };
}

export interface LegalPage {
  title: string;
  slug: { current: string };
  effectiveDate?: string;
  body: PortableTextBlock[];
  seo?: LegalPageSeo;
}

export const legalPageBySlugQuery = `
  *[_type == "legalPage" && slug.current == $slug][0] {
    title,
    slug,
    effectiveDate,
    body[]{
      ...,
      markDefs[]{
        ...
      }
    },
    seo {
      metaTitle,
      metaDescription,
      canonicalUrl,
      isHiddenFromSearch,
      ogImage {
        asset->{ url }
      }
    }
  }
`;

export const getLegalPage = async (slug: string): Promise<LegalPage | null> => {
  try {
    const page = await sanityClient.fetch<LegalPage | null>(
      legalPageBySlugQuery,
      { slug }
    );
    return page ?? null;
  } catch (error) {
    console.error(
      `[legalPage] failed to fetch "${slug}" from Sanity`,
      error
    );
    return null;
  }
};
